export default {"src":"/_next/static/media/check.e82519a8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};